import React from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STAGE_STYLE = {
  "Goal Setting":  "text-white/50 bg-white/5 border-white/10",
  "Self":          "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  "Mgr Review":    "text-blue-400 bg-blue-500/10 border-blue-500/20",
  "Peer":          "text-purple-400 bg-purple-500/10 border-purple-500/20",
  "360":           "text-cyan-400 bg-cyan-500/10 border-cyan-500/20",
  "Calibration":   "text-orange-400 bg-orange-500/10 border-orange-500/20",
  "Finalize":      "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
};

const METHOD_STYLE = {
  "KRA/KPI": "text-[#00ff90]/60",
  "OKR":     "text-blue-400/60",
  "360":     "text-purple-400/60",
  "MBO":     "text-yellow-400/60",
  "BARS":    "text-cyan-400/60",
};

function ratingColor(r) {
  if (!r) return "rgba(255,255,255,0.2)";
  if (r >= 4.5) return "#00ff90";
  if (r >= 3.5) return "#60a5fa";
  if (r >= 2.5) return "#fbbf24";
  return "#f87171";
}

export default function PerformanceReviewsGrid({ rows, onOpen }) {
  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Reviews</span>
        <span className="text-xs text-white/30">{rows?.length || 0} records</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/5">
              {["Employee","Dept","Location","Manager","Method","Rating","Goals","Stage",""].map(h => (
                <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!rows?.length ? (
              <tr><td colSpan={9} className="px-4 py-8 text-center text-white/20 italic text-sm">No reviews in this cycle.</td></tr>
            ) : rows.map(r => {
              const stageStyle  = STAGE_STYLE[r.stage]  || "text-white/40 bg-white/5 border-white/10";
              const methodColor = METHOD_STYLE[r.method] || "text-white/30";
              return (
                <tr key={r.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
                  <td className="px-3 py-3">
                    <button onClick={() => onOpen?.(r)} className="text-left hover:text-[#00ff90] transition-colors">
                      <p className="text-sm text-white/80 font-medium">{r.name}</p>
                      <p className="text-xs text-white/30">{r.empCode}</p>
                    </button>
                  </td>
                  <td className="px-3 py-3 text-white/40 text-xs">{r.dept}</td>
                  <td className="px-3 py-3 text-white/40 text-xs">{r.location}</td>
                  <td className="px-3 py-3 text-white/40 text-xs">{r.manager}</td>
                  <td className="px-3 py-3">
                    <span className={`text-xs font-medium ${methodColor}`}>{r.method || "—"}</span>
                  </td>
                  <td className="px-3 py-3">
                    <span className="text-sm font-bold" style={{ color: ratingColor(r.rating) }}>
                      {r.rating?.toFixed?.(1) ?? "—"}
                    </span>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-1.5">
                      <div className="h-1.5 w-16 rounded-full bg-white/5">
                        <div className="h-full rounded-full bg-[#00ff90]" style={{ width: `${Math.round((r.goalsProgress || 0) * 100)}%` }} />
                      </div>
                      <span className="text-xs text-white/30">{Math.round((r.goalsProgress || 0) * 100)}%</span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <span className={`text-xs px-2 py-0.5 rounded-full border ${stageStyle}`}>{r.stage || "—"}</span>
                  </td>
                  <td className="px-3 py-3">
                    <button onClick={() => onOpen?.(r)}
                      className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                      Open
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}